<template>
  <v-dialog v-model="dialog" width="350" persistent>
    <v-card>
      <v-card-title ss="headline grey lighten-2" primary-title>
        Cotação
      </v-card-title>
      <v-card-text>
        <span>Deseja abrir cotação após gerar o relatório?</span>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="primary" text @click="nao">Não</v-btn>
        <v-btn color="primary" text @click="sim">Sim</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["dialogCotacao"],

  data: () => ({
    dialog: false,
  }),

  watch: {
    dialogCotacao: function () {
      this.dialog = this.dialogCotacao;
    },
  },

  methods: {
    sim: function () {
      this.$emit("cotacaoAposRelatorio", true);
    },
    nao: function () {
      this.$emit("cotacaoAposRelatorio", false);
    },
  },
};
</script>
